import DomPurify from 'dompurify'
import { marked } from 'marked'

export const markdownToHtml = (markdown) => {
  return DomPurify.sanitize(marked.parse(markdown || ''))
}
